import { BrowserRouter, Route, Routes, RouterProvider, createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

import RequireAuth from '@auth-kit/react-router/RequireAuth'

import { Home } from "./components/Home";
import { Login } from "./components/Login";
import Events from "./components/events/index";
import Event from "./components/events/Event";
import Kiosk from "./components/events/Kiosk";
import Register from "./components/profile/Register";
import Profile from "./components/profile/index";
import ResetPassword from "./components/profile/ResetPassword";
import ScrollToTop from './ScrollToTop.js';


//const Routes = () => {
//    const { token } = useAuth();

//    const publicRoutes = [
//        {
//            path: "/",
//            element: <Home />,
//        },
//    ];
//    const authenticatedRoutes = [
//        {
//            path: "/",
//            element: <ProtectedRoute />,
//            children: [
//                ...AppRoutes,
//                {
//                    path: "",
//                    element: <div>User Home Page</div>,
//                },
//                {
//                    path: "/register",
//                    element: <div>register</div>,
//                },
//                {
//                    path: "/logout",
//                    element: <div>Logout</div>,
//                },
//            ]
//        },
//    ];
//    const notAuthenticatedRoutes = [
//        {
//            path: "/",
//            element: <div>Home Page</div>,
//        },
//        {
//            path: "/login",
//            element: <Login />,
//        },
//    ];

//    const router = createBrowserRouter([
//        ...publicRoutes,
//        ...(!token ? notAuthenticatedRoutes : []),
//        ...authenticatedRoutes,
//    ]);

//    return <RouterProvider router={router} basename="/" />;
//};

/*export default Routes;*/
import { Layout } from './components/Layout';
import { Events as ProfileEvents } from "./components/profile/Events";
import SmartRequireAuth from "./components/SmartRequireAuth";

//<RequireAuth fallbackPath={'/login'}>
//<Profile />
//</RequireAuth>

const RoutesComponent = () => {
    return (
        /*<Layout>*/
        <BrowserRouter>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route path={'/'} element={<Home />} />
                    <Route path={'/login'} element={<Login />} />
                    <Route path={'/profile/register'} element={<Register />} />
                    <Route path={'/profile/resetpassword'} element={<ResetPassword />} />
                    <Route path={'/events'} element={<Events />} />
                    <Route path={'/events/:eventCode'} element={<Event />} />
                    <Route path={'/events/:eventCode/registration/:registrationCode'} element={<Event retrievePass />} />
                    <Route path={'/events/:eventCode/registration/:registrationCode/pass'} element={<Event retrievePass viewPass />} />
                    <Route path={'/events/:eventCode/pass/:passCode'} element={<Event retrievePass pc />} />
                    <Route path={'/events/:eventCode/kiosk'} element={<Kiosk />} />
                    <Route path={'/profile'} element={
                        <SmartRequireAuth>
                            <Profile />
                        </SmartRequireAuth>
                    } />
                    <Route path={'/profile/events'} element={
                        <SmartRequireAuth>
                            <ProfileEvents />
                        </SmartRequireAuth>
                    } />
                    <Route path={'/profile/student/:studentId'} element={
                        <SmartRequireAuth>
                            <Profile />
                        </SmartRequireAuth>
                    } />
                    {/*<Route path={'/tournament'} element={*/}
                    {/*    <RequireAuth fallbackPath={'/login'}>*/}
                    {/*        <Tournament />*/}
                    {/*    </RequireAuth>*/}
                    {/*} />*/}
                    {/*<Route path={'/competitors'} element={*/}
                    {/*    <RequireAuth fallbackPath={'/login'}>*/}
                    {/*        <Competitors />*/}
                    {/*    </RequireAuth>*/}
                    {/*} />*/}
                </Routes>
            </Layout>
        </BrowserRouter>
        /*</Layout>*/
    )
};
export default RoutesComponent;

const ProtectedRoute = () => {
    const { token } = useAuth();

    // Check if the user is authenticated
    if (!token) {
        // If not authenticated, redirect to the login page
        return <Navigate to="/login" />;
    }

    // If authenticated, render the child routes
    return <Outlet />;
};

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
//    {
//        path: '/competitors',
//        element: <Competitors />
//    },
//    {
//        path: '/pos',
//        element: <POS />
//    },
//    {
//        path: '/testing',
//        element: <Testing />
//    },
//    {
//        path: '/testing/complete',
//        element: <Complete />
//    },
];

/*export default AppRoutes;*/
